var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stepper',{staticClass:"pt-8 lg:pt-16",attrs:{"primary-color":"#3a473c"},on:{"step-click":function($event){return _vm.go($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }